import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {CapitalizePipe} from './capitalize.pipe';
import {HufPipe} from './huf.pipe';
import {MomentPipe} from './moment.pipe';
import {NamePipe} from './name.pipe';
import {RolePipe} from './role.pipe';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        CapitalizePipe,
        HufPipe,
        MomentPipe,
        NamePipe,
        RolePipe,
    ],
    exports: [
        CapitalizePipe,
        HufPipe,
        MomentPipe,
        NamePipe,
        RolePipe,
    ]
})
export class PipesModule {
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/pipes/pipes.module.ts